// Re:Focus — Application Constants
// Pure constant values with no side effects

export const PRESET_COLORS = ['#e06c75', '#d19a66', '#e5c07b', '#98c379', '#56b6c2', '#61afef', '#c678dd', '#bb9af7'];

export const DEFAULT_SUB_COLUMNS = [
  { id: 'todo', title: 'To Do', emoji: '\ud83d\udccb' },
  { id: 'inprogress', title: 'In Progress', emoji: '\ud83d\udd04' },
  { id: 'done', title: 'Done', emoji: '\u2705' }
];

export const STATUS_OPTIONS = ['Active', 'Waiting', 'Done'];

export const STATUS_COLORS = {
  'Active':     { bg: 'rgba(255, 180, 120, 0.2)', color: '#ffb478', dot: '#ffb478' },
  'Waiting':    { bg: 'rgba(122, 162, 247, 0.18)', color: '#7aa2f7', dot: '#7aa2f7' },
  'Done':       { bg: 'rgba(158, 206, 106, 0.15)', color: '#6a9955', dot: '#6a9955' },
  // Legacy Sprint 2 compat → reverted 3-state
  'Ripe':       { bg: 'rgba(255, 180, 120, 0.2)', color: '#ffb478', dot: '#ffb478' },
  'Future Now': { bg: 'rgba(122, 162, 247, 0.18)', color: '#7aa2f7', dot: '#7aa2f7' },
  'Delegate':   { bg: 'rgba(187, 154, 247, 0.18)', color: '#bb9af7', dot: '#bb9af7' },
  // Legacy granular compat
  'Blocked':                { bg: 'rgba(122, 162, 247, 0.18)', color: '#7aa2f7', dot: '#7aa2f7' },
  'On Hold':                { bg: 'rgba(122, 162, 247, 0.18)', color: '#7aa2f7', dot: '#7aa2f7' },
  'In Progress':            { bg: 'rgba(122, 162, 247, 0.18)', color: '#7aa2f7', dot: '#7aa2f7' },
  'Not started':            { bg: 'rgba(122, 162, 247, 0.18)', color: '#7aa2f7', dot: '#7aa2f7' },
  'In progress':            { bg: 'rgba(122, 162, 247, 0.18)', color: '#7aa2f7', dot: '#7aa2f7' },
  'Waiting For':            { bg: 'rgba(122, 162, 247, 0.18)', color: '#7aa2f7', dot: '#7aa2f7' },
  'Confirmed':              { bg: 'rgba(158, 206, 106, 0.15)', color: '#6a9955', dot: '#6a9955' },
  'Preliminary Design':     { bg: 'rgba(122, 162, 247, 0.18)', color: '#7aa2f7', dot: '#7aa2f7' },
  'Design':                 { bg: 'rgba(122, 162, 247, 0.18)', color: '#7aa2f7', dot: '#7aa2f7' },
  'Pre Production':         { bg: 'rgba(122, 162, 247, 0.18)', color: '#7aa2f7', dot: '#7aa2f7' },
  'In Production':          { bg: 'rgba(122, 162, 247, 0.18)', color: '#7aa2f7', dot: '#7aa2f7' },
  'Provisionally Complete': { bg: 'rgba(158, 206, 106, 0.15)', color: '#6a9955', dot: '#6a9955' }
};

// Core actionable context tags (no 'waiting' — it gets its own special group in the NA panel)
export const CTX_TAGS = ['call', 'desk', 'site', 'zoom', 'remote', 'email', 'computer', 'errand', 'delegate', 'research', 'draft'];
